import { render } from "./UgTransCourierDeliveryBanner.vue?vue&type=template&id=3d339c98&scoped=true"
import script from "./UgTransCourierDeliveryBanner.vue?vue&type=script&lang=js"
export * from "./UgTransCourierDeliveryBanner.vue?vue&type=script&lang=js"

import "./UgTransCourierDeliveryBanner.vue?vue&type=style&index=0&id=3d339c98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d339c98"]])

export default __exports__